var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGitCommit = function SvgIconGitCommit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 6.125A5.876 5.876 0 0 1 17.79 11h5.085a1 1 0 1 1 0 2h-5.086a5.876 5.876 0 0 1-11.578 0H1.125a1 1 0 1 1 0-2h5.086A5.876 5.876 0 0 1 12 6.125m0 2a3.875 3.875 0 1 0 0 7.75 3.875 3.875 0 0 0 0-7.75"
  })));
};
export default SvgIconGitCommit;